import "./TrustedCompanies.scss";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { icons } from "../../../utils/icons";
import { baseUrl } from "../../../utils/apiData";

function PrevArrow({ onClick }) {
  return (
    <button className="arrowbtn prev" type="button" onClick={onClick}>
      <img src={icons.leftDarkArrow} alt="arrow" />
    </button>
  );
}

function NextArrow({ onClick }) {
  return (
    <button className="arrowbtn next" type="button" onClick={onClick}>
      <img src={icons.rightDarkArrow} alt="arrow" />
    </button>
  );
}

const TrustedCompanies = ({ slideData, theme }) => {
  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    speed: 1000,
    autoplaySpeed: 2000,
    slidesToShow: 5,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 400,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
    ],
  };

  return (
    <section className={`trusted_companies ${theme ? "dark" : "light"}`}>
      <div className="content_wrap p_bottom">
        <h5 className="t-12 wow fadeInUp">OUR TRUSTED VENDORS</h5>
        {slideData?.length > 0 ? (
          <div className="slider_sec wow fadeInUp">
            <Slider {...settings}>
              {slideData?.length > 0 &&
                slideData?.map((data) => {
                  return (
                    <div className="slider_wrap" key={data?._id}>
                      <div className="img_wrap">
                        <img src={`${baseUrl}/${data?.image}`} alt="logo" />
                      </div>
                    </div>
                  );
                })}
            </Slider>
          </div>
        ) : (
          <p className="text-center mt-4" style={{ color: "white" }}>
            Data not Found...
          </p>
        )}
      </div>
    </section>
  );
};

export default TrustedCompanies;
